var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3177 23.9997C30.3177 27.8527 27.2042 30.9662 23.3513 30.9662C19.4983 30.9662 16.3848 27.8527 16.3848 23.9997C16.3848 20.1467 19.4983 17.0332 23.3513 17.0332C27.2042 17.0332 30.3177 20.1467 30.3177 23.9997Z",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3511 40.0931C30.2203 40.0931 36.6225 36.0455 41.0787 29.0401C42.8301 26.2963 42.8301 21.6845 41.0787 18.9407C36.6225 11.9353 30.2203 7.8877 23.3511 7.8877C16.4819 7.8877 10.0798 11.9353 5.62357 18.9407C3.87222 21.6845 3.87222 26.2963 5.62357 29.0401C10.0798 36.0455 16.4819 40.0931 23.3511 40.0931Z",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEopen);
export default __webpack_public_path__ + "static/media/eopen.246f07c68679cf76da641e3857adcbd3.svg";
export { ForwardRef as ReactComponent };